import React, { useMemo, useRef, useEffect, useState } from 'react';

import {
  OptionHintRoot,
  OptionHintText,
  OptionHintArrow,
} from '@/components/Tables/Cells/ListCell/options/StyledComponents';

const OptionHint = ({ text, optionEl, width }) => {
  const el = useRef(null);
  const [hintHeight, setHintHeight] = useState(0);

  const isShow = useMemo(() => optionEl.offsetWidth > width, [width, optionEl]);

  useEffect(() => {
    setTimeout(() => {
      if (el.current) {
        setHintHeight(el.current.offsetHeight);
      }
    }, 0);
  }, [optionEl]);

  const style = useMemo(() => {
    const { x, y } = optionEl.getBoundingClientRect();
    return {
      top: y - hintHeight - 10,
      left: x,
      maxWidth: width,
      // minWidth: width,
    };
  }, [optionEl, hintHeight, width]);

  return isShow ? (
    <OptionHintRoot ref={el} style={style}>
      <OptionHintText>{text}</OptionHintText>
      <OptionHintArrow />
    </OptionHintRoot>
  ) : null;
};

export default OptionHint;
